(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["namma-closing"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('namma-closing-buy')) {
    customElements.define('namma-closing-buy', class extends HTMLElement {
      connectedCallback() {
        this.events?.abort();
        this.events = new AbortController();
        this.form = this.querySelector('form');
        this.button = this.querySelector('button[type="submit"]');
        this.label = this.querySelector('[data-buy-label]');
        this.status = this.querySelector('[data-buy-status]');
        this.error = this.querySelector('[data-buy-error]');
        if (!this.form || !this.button) return;
        this.originalLabel = this.label.textContent;
        this.addEventListener('submit', event => this.buy(event), { signal: this.events.signal });
        window.addEventListener('pageshow', () => this.reset(), { signal: this.events.signal });
      }
      disconnectedCallback() { this.events?.abort(); }
      reset() {
        this.busy = false;
        this.button.disabled = false;
        this.button.removeAttribute('aria-busy');
        this.label.textContent = this.originalLabel;
        this.status.hidden = true;
        this.form.querySelector('select')?.removeAttribute('disabled');
      }
      async buy(event) {
        event.preventDefault();
        event.stopPropagation();
        if (this.busy || this.button.disabled || !this.form.reportValidity()) return;
        this.busy = true;
        this.error.hidden = true;
        const body = new FormData(this.form);
        this.button.disabled = true;
        this.button.setAttribute('aria-busy', 'true');
        this.label.textContent = this.dataset.loadingLabel;
        this.status.textContent = this.dataset.loadingLabel;
        this.status.hidden = false;
        this.form.querySelector('select')?.setAttribute('disabled', '');
        try {
          const endpoint = new URL(this.form.action);
          endpoint.pathname += '.js';
          const response = await fetch(endpoint, { method: 'POST', body, credentials: 'same-origin', headers: { Accept: 'application/json' } });
          if (!response.ok) {
            const data = await response.json().catch(() => ({}));
            throw new Error(typeof data.description === 'string' ? data.description : this.dataset.errorLabel);
          }
          this.label.textContent = this.dataset.checkoutLabel;
          this.status.textContent = this.dataset.checkoutLabel;
          window.location.assign(this.form.elements.return_to.value);
        } catch (failure) {
          this.error.textContent = failure instanceof TypeError ? this.dataset.errorLabel : failure.message || this.dataset.errorLabel;
          this.error.hidden = false;
          this.reset();
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["namma-faq"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('namma-faq-v1')) {
    customElements.define('namma-faq-v1', class extends HTMLElement {
      connectedCallback() {
        if (this._onSelect) return;
        this._onSelect = (event) => {
          const item = event.target.closest('.nf-faq__item');
          if (item && this.contains(item)) item.open = true;
        };
        this.addEventListener('shopify:block:select', this._onSelect);
      }
      disconnectedCallback() {
        this.removeEventListener('shopify:block:select', this._onSelect);
        this._onSelect = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["namma-footer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('namma-footer-v1')) {
    customElements.define('namma-footer-v1', class extends HTMLElement {
      connectedCallback() { this.frame = requestAnimationFrame(() => this.initialize()); }
      disconnectedCallback() { cancelAnimationFrame(this.frame); this.events?.abort(); this.motionObserver?.disconnect(); }
      initialize() {
        this.events?.abort();
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        const mobile = matchMedia('(max-width: 749px)');
        const menus = [...this.querySelectorAll('[data-footer-menu]')];
        const update = () => menus.forEach(menu => {
          menu.open = !mobile.matches;
          menu.querySelector('summary').tabIndex = mobile.matches ? 0 : -1;
        });
        update();
        mobile.addEventListener('change', update, options);
        menus.forEach(menu => menu.querySelector('summary').addEventListener('click', event => {
          if (!mobile.matches) event.preventDefault();
        }, options));
        this.addEventListener('shopify:block:select', event => {
          const menu = menus.find(item => item.dataset.blockId === event.detail?.blockId);
          if (menu) menu.open = true;
        }, options);
        this.initializeMotion(options);
        const country = this.querySelector('[data-country]');
        if (!country) return;
        document.addEventListener('click', event => {
          if (country.open && !country.contains(event.target)) country.open = false;
        }, options);
        this.addEventListener('keydown', event => {
          if (event.key === 'Escape' && country.open) {
            country.open = false;
            country.querySelector('summary').focus();
          }
        }, options);
      }
      initializeMotion(options) {
        this.motionPreference = matchMedia('(prefers-reduced-motion: reduce)');
        this.motionButton = this.querySelector('[data-motion-toggle]');
        if (this.motionButton) {
          this.motionButton.hidden = this.dataset.animate !== 'true';
          this.motionButton.addEventListener('click', () => this.setMotion(this.dataset.motionState !== 'running', true), options);
        }
        this.motionPreference.addEventListener('change', () => this.setMotion(!this.motionPreference.matches), options);
        const visibility = () => { this.dataset.documentHidden = String(document.hidden); };
        document.addEventListener('visibilitychange', visibility, options);
        visibility();
        this.motionObserver?.disconnect();
        const scene = this.querySelector('[data-nature-scene]');
        const edge = this.querySelector('[data-wave-edge]');
        const targets = [scene, edge].filter(Boolean);
        const visibleClass = target => target === scene ? 'nf-footer__scene--visible' : 'nf-footer__edge--visible';
        if ('IntersectionObserver' in window) {
          this.motionObserver = new IntersectionObserver(entries => {
            entries.forEach(entry => entry.target.classList.toggle(visibleClass(entry.target), entry.isIntersecting));
          }, { threshold: .1 });
          targets.forEach(target => this.motionObserver.observe(target));
        } else {
          targets.forEach(target => target.classList.add(visibleClass(target)));
        }
        this.setMotion(!this.motionPreference.matches);
      }
      setMotion(enabled, explicit = false) {
        const active = enabled && this.dataset.animate === 'true';
        this.dataset.motionState = active ? 'running' : 'paused';
        this.dataset.motionExplicit = String(explicit);
        this.dispatchEvent(new CustomEvent('namma-footer:motion-change', { bubbles: true, detail: { running: active } }));
        if (this.motionButton) {
          this.motionButton.querySelector('[data-motion-label]').textContent = active ? this.motionButton.dataset.pauseLabel : this.motionButton.dataset.playLabel;
          this.motionButton.querySelector('[data-motion-play]').toggleAttribute('hidden', active);
          this.motionButton.querySelector('[data-motion-pause]').toggleAttribute('hidden', !active);
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["namma-header"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('namma-illustrated-header')) {
    customElements.define('namma-illustrated-header', class extends HTMLElement {
      connectedCallback() {
        this.lifecycle?.abort();
        this.lifecycle = new AbortController();
        const options = { signal: this.lifecycle.signal };
        this.menuButton = this.querySelector('[data-open-menu]');
        this.menuDialog = this.querySelector('[data-menu-dialog]');
        this.searchDialog = this.querySelector('[data-search-dialog]');
        this.count = this.querySelector('[data-cart-count]');
        this.menuButton.addEventListener('click', () => this.openDialog(this.menuDialog, this.menuButton), options);
        this.querySelector('[data-open-search]')?.addEventListener('click', (event) => {
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          this.openDialog(this.searchDialog, event.currentTarget);
        }, options);
        this.querySelectorAll('dialog').forEach((dialog) => {
          dialog.addEventListener('keydown', (event) => {
            if (event.key !== 'Tab') return;
            const focusable = [...dialog.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), summary, [tabindex="0"]')].filter((node) => node.getClientRects().length && getComputedStyle(node).visibility !== 'hidden');
            const first = focusable[0];
            const last = focusable[focusable.length - 1];
            if (event.shiftKey && document.activeElement === first) {
              event.preventDefault();
              last?.focus();
            } else if (!event.shiftKey && document.activeElement === last) {
              event.preventDefault();
              first?.focus();
            }
          }, options);
          dialog.addEventListener('click', (event) => {
            if (event.target.closest('[data-close-dialog]')) {
              dialog.close();
              this.restorePage(dialog);
            }
            if (event.target === dialog) {
              const rect = dialog.getBoundingClientRect();
              if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) {
                dialog.close();
                this.restorePage(dialog);
              }
            }
          }, options);
          dialog.addEventListener('close', () => this.restorePage(dialog), options);
        });
        this.menuDialog.addEventListener('click', (event) => {
          if (event.target.closest('a')) {
            this.menuDialog.close();
            this.restorePage(this.menuDialog);
          }
        }, options);
        this.addEventListener('keydown', (event) => {
          if (event.key !== 'Escape') return;
          const opened = event.target.closest('details[open]');
          if (!opened) {
            if (this.activeDialog) {
              event.preventDefault();
              event.stopPropagation();
              this.activeDialog.close();
              this.restorePage(this.activeDialog);
            }
            return;
          }
          event.preventDefault();
          event.stopPropagation();
          opened.open = false;
          opened.querySelector('summary').focus();
        }, options);
        document.addEventListener('click', (event) => {
          this.querySelectorAll('.nih__desktop-nav details[open]').forEach((details) => {
            if (!details.contains(event.target)) details.open = false;
          });
        }, options);
        this.addEventListener('focusout', () => {
          clearTimeout(this.focusTimer);
          this.focusTimer = setTimeout(() => {
            this.querySelectorAll('.nih__desktop-nav details[open]').forEach((details) => {
              if (!details.contains(document.activeElement)) details.open = false;
            });
          }, 0);
        }, options);
        this.breakpoint = matchMedia('(min-width: 1100px)');
        this.breakpoint.addEventListener('change', () => {
          if (this.breakpoint.matches && this.menuDialog.open) this.menuDialog.close();
          this.querySelectorAll('details[open]').forEach((details) => { details.open = false; });
        }, options);
        const preview = this.dataset.editorPreview || 'scroll';
        this.classList.toggle('nih--compact', preview === 'compact');
        if (preview === 'scroll' && this.dataset.compact === 'true') {
          const update = () => {
            if (this.scrollFrame || this.activeDialog) return;
            this.scrollFrame = requestAnimationFrame(() => {
              if (this.activeDialog) {
                this.scrollFrame = 0;
                return;
              }
              const compact = this.classList.contains('nih--compact');
              if (window.scrollY > 150 || window.scrollY < 24) this.classList.toggle('nih--compact', window.scrollY > 150);
              if (compact !== this.classList.contains('nih--compact')) this.querySelectorAll('.nih__desktop-nav details[open]').forEach((details) => { details.open = false; });
              this.scrollFrame = 0;
            });
          };
          window.addEventListener('scroll', update, { ...options, passive: true });
          window.addEventListener('pageshow', update, options);
          update();
        }
        const refresh = (event) => {
          const cart = event?.detail?.cart || event?.detail;
          if (Number.isInteger(cart?.item_count)) {
            clearTimeout(this.cartTimer);
            this.cartRequest?.abort();
            this.setCount(cart.item_count);
          }
          else this.scheduleCartRefresh();
        };
        ['cart:updated', 'cart:refresh', 'cart:change', 'namma:cart-updated'].forEach((name) => document.addEventListener(name, refresh, options));
        window.addEventListener('pageshow', refresh, options);
        window.addEventListener('focus', refresh, options);
        this.querySelector('.nih__cart').addEventListener('pointerenter', refresh, options);
        this.querySelector('.nih__cart').addEventListener('focus', refresh, options);
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, refresh);
      }
      openDialog(dialog, trigger) {
        if (!dialog || dialog.open) return;
        if (this.activeDialog) {
          const previous = this.activeDialog;
          previous.close();
          this.restorePage(previous);
        }
        this.returnFocus = trigger;
        this.activeDialog = dialog;
        this.savedScroll = window.scrollY;
        this.savedBodyStyle = ['position', 'top', 'left', 'right', 'width', 'overflow'].map((name) => [name, document.body.style.getPropertyValue(name), document.body.style.getPropertyPriority(name)]);
        Object.assign(document.body.style, { position: 'fixed', top: `-${this.savedScroll}px`, left: '0', right: '0', width: '100%', overflow: 'hidden' });
        dialog.showModal();
        this.menuButton.setAttribute('aria-expanded', String(dialog === this.menuDialog));
      }
      restorePage(dialog) {
        if (dialog !== this.activeDialog) return;
        this.savedBodyStyle?.forEach(([name, value, priority]) => {
          if (value) document.body.style.setProperty(name, value, priority);
          else document.body.style.removeProperty(name);
        });
        window.scrollTo({ top: this.savedScroll, behavior: 'instant' });
        this.activeDialog = null;
        this.menuButton.setAttribute('aria-expanded', 'false');
        if (this.returnFocus?.isConnected && this.returnFocus.getClientRects().length) this.returnFocus.focus({ preventScroll: true });
      }
      setCount(count) {
        if (!Number.isInteger(count) || count < 0) return;
        this.count.textContent = String(count);
        this.count.hidden = count === 0;
      }
      scheduleCartRefresh() {
        clearTimeout(this.cartTimer);
        this.cartTimer = setTimeout(() => this.refreshCart(), 120);
      }
      async refreshCart() {
        this.cartRequest?.abort();
        this.cartRequest = new AbortController();
        try {
          const response = await fetch(this.dataset.cartUrl, { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' }, signal: this.cartRequest.signal });
          if (!response.ok) return;
          const cart = await response.json();
          if (this.isConnected) this.setCount(cart.item_count);
        } catch {}
      }
      disconnectedCallback() {
        if (this.activeDialog) {
          this.activeDialog.close();
          this.restorePage(this.activeDialog);
        }
        this.lifecycle?.abort();
        this.cartRequest?.abort();
        this.unsubscribe?.();
        cancelAnimationFrame(this.scrollFrame);
        this.scrollFrame = 0;
        clearTimeout(this.cartTimer);
        clearTimeout(this.focusTimer);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["namma-makers"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('namma-makers-v1')) {
    customElements.define('namma-makers-v1', class extends HTMLElement {
      connectedCallback() {
        this.rail = this.querySelector('[data-rail]');
        if (!this.rail) return;
        this.cards = Array.from(this.querySelectorAll('[data-maker]'));
        this.navigation = this.querySelector('[data-navigation]');
        this.previous = this.querySelector('[data-previous]');
        this.next = this.querySelector('[data-next]');
        this.counter = this.querySelector('[data-current]');
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.previous.addEventListener('click', () => this.move(-1), options);
        this.next.addEventListener('click', () => this.move(1), options);
        this.rail.addEventListener('scroll', () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.update());
        }, { ...options, passive: true });
        this.rail.addEventListener('keydown', event => {
          if (event.target.matches('summary, a, button, input, textarea, select')) return;
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            this.move(event.key === 'ArrowRight' ? 1 : -1);
          }
        }, options);
        this.addEventListener('shopify:block:select', event => {
          const card = event.target.closest('[data-maker]');
          if (card) this.scrollToCard(card, 'auto');
        }, options);
        this.observer = new ResizeObserver(() => this.update());
        this.observer.observe(this.rail);
        this.update();
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.observer?.disconnect();
        cancelAnimationFrame(this.frame);
      }
      update() {
        const maximum = this.rail.scrollWidth - this.rail.clientWidth;
        const position = Math.abs(this.rail.scrollLeft);
        this.navigation.hidden = maximum < 3;
        this.previous.disabled = position < 3;
        this.next.disabled = position >= maximum - 3;
        const railBox = this.rail.getBoundingClientRect();
        const rtl = getComputedStyle(this.rail).direction === 'rtl';
        let nearest = 0;
        let distance = Infinity;
        this.cards.forEach((card, index) => {
          const box = card.getBoundingClientRect();
          const offset = Math.abs(rtl ? railBox.right - box.right : box.left - railBox.left);
          if (offset < distance) { nearest = index; distance = offset; }
        });
        this.index = nearest;
        this.counter.textContent = String(nearest + 1);
      }
      move(direction) {
        const nextIndex = Math.max(0, Math.min(this.cards.length - 1, this.index + direction));
        this.scrollToCard(this.cards[nextIndex]);
      }
      scrollToCard(card, behavior) {
        const railBox = this.rail.getBoundingClientRect();
        const cardBox = card.getBoundingClientRect();
        const rtl = getComputedStyle(this.rail).direction === 'rtl';
        const offset = rtl ? cardBox.right - railBox.right : cardBox.left - railBox.left;
        this.rail.scrollBy({ left: offset, behavior: behavior || (matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth') });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["namma-product-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('namma-product-hero')) {
  customElements.define('namma-product-hero', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.events = { signal: this.controller.signal };
      this.form = this.querySelector('.np__form');
      if (!this.form) return;
      this.quantity = this.querySelector('[data-quantity]');
      this.variantSelect = this.querySelector('[data-variant-select]');
      this.mainButton = this.querySelector('[data-buy-now]');
      this.stickyButton = this.querySelector('[data-sticky-cart]');
      this.bar = this.querySelector('[data-mobile-bar]');
      this.available = !this.mainButton.disabled;
      this.busy = false;
      this.slides = [...this.querySelectorAll('[data-slide]')];
      this.thumbs = [...this.querySelectorAll('[data-thumb]')];
      this.current = 0;
      this.slides[0]?.classList.add('is-current');
      this.galleryRequest = 0;
      const details = this.querySelector('.np__details');
      const syncGalleryHeight = () => {
        if (!details || !matchMedia('(min-width:960px)').matches) return;
        this.style.setProperty('--np-gallery-height', `${details.getBoundingClientRect().height}px`);
      };
      syncGalleryHeight();
      if ('ResizeObserver' in window && details) {
        this.gallerySizeObserver = new ResizeObserver(syncGalleryHeight);
        this.gallerySizeObserver.observe(details);
      }
      window.addEventListener('resize', syncGalleryHeight, this.events);

      this.thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => this.showSlide(index), this.events));
      const rail = this.querySelector('.np__thumbs');
      const previousRail = this.querySelector('[data-rail-prev]');
      const nextRail = this.querySelector('[data-rail-next]');
      const updateRailButtons = () => {
        if (!rail) return;
        previousRail.disabled = this.slides.length < 2;
        nextRail.disabled = this.slides.length < 2;
      };
      const navigateImage = (event, direction) => {
        if (!matchMedia('(min-width:960px)').matches) return;
        event.preventDefault();
        event.stopPropagation();
        this.showSlide((this.requestedGalleryIndex ?? this.current) + direction);
      };
      previousRail?.addEventListener('click', event => navigateImage(event, -1), this.events);
      nextRail?.addEventListener('click', event => navigateImage(event, 1), this.events);
      rail?.addEventListener('scroll', updateRailButtons, { ...this.events, passive:true });
      if (rail && 'ResizeObserver' in window) {
        this.railObserver = new ResizeObserver(updateRailButtons);
        this.railObserver.observe(rail);
      }
      updateRailButtons();
      const stage = this.querySelector('[data-stage]');
      if (!matchMedia('(min-width:960px)').matches) {
        this.thumbs.forEach(thumb => { const image = thumb.querySelector('img'); if (image) image.loading = 'eager'; });
      }
      stage?.addEventListener('touchstart', () => {
        if (matchMedia('(min-width:960px)').matches) return;
        this.mobileImageRequest = (this.mobileImageRequest || 0) + 1;
        this.mobileScrollTarget = null;
        clearTimeout(this.mobileSettleTimer);
      }, { ...this.events, passive:true });
      let galleryFrame;
      stage?.addEventListener('scroll', () => {
        if (matchMedia('(min-width:960px)').matches) return;
        if (this.mobileScrollTarget != null) {
          clearTimeout(this.mobileSettleTimer);
          this.mobileSettleTimer = setTimeout(() => { this.mobileScrollTarget = null; }, 180);
          return;
        }
        cancelAnimationFrame(galleryFrame);
        galleryFrame = requestAnimationFrame(() => {
          const stageLeft = stage.getBoundingClientRect().left;
          let closest = 0;
          let distance = Infinity;
          this.slides.forEach((slide, index) => {
            const delta = Math.abs(slide.getBoundingClientRect().left - stageLeft);
            if (delta < distance) { distance = delta; closest = index; }
          });
          if (closest !== this.current) this.updateGallery(closest);
        });
      }, { ...this.events, passive: true });
      stage?.addEventListener('keydown', event => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        this.showSlide(this.current + (event.key === 'ArrowRight' ? 1 : -1));
      }, this.events);
      this.querySelector('[data-qty-minus]').addEventListener('click', () => this.changeQuantity(-1), this.events);
      this.querySelector('[data-qty-plus]').addEventListener('click', () => this.changeQuantity(1), this.events);
      this.quantity.addEventListener('change', () => this.normalizeQuantity(), this.events);
      this.quantity.addEventListener('input', () => this.syncQuantity(), this.events);
      this.variantSelect?.addEventListener('change', () => this.updateVariant(true), this.events);
      this.form.addEventListener('submit', event => {
        event.preventDefault();
        this.buyNow();
      }, this.events);
      this.updateVariant(false);
      if (this.dataset.stickyEnabled === 'true') {
        const updateSticky = () => {
          if (this.stickyFrame) return;
          this.stickyFrame = requestAnimationFrame(() => {
            this.bar.hidden = this.mainButton.getBoundingClientRect().bottom > 0;
            this.stickyFrame = null;
          });
        };
        window.addEventListener('scroll', updateSticky, { ...this.events, passive: true });
        window.addEventListener('resize', updateSticky, this.events);
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(updateSticky, { threshold: 0 });
          this.observer.observe(this.mainButton);
        }
        updateSticky();
      }
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.galleryRequest++;
      this.mobileImageRequest = (this.mobileImageRequest || 0) + 1;
      clearTimeout(this.mobileSettleTimer);
      this.observer?.disconnect();
      this.gallerySizeObserver?.disconnect();
      this.railObserver?.disconnect();
      cancelAnimationFrame(this.stickyFrame);
      this.stickyFrame = null;
      this.controller = null;
    }
    showSlide(index) {
      if (!this.slides.length) return;
      const next = (index + this.slides.length) % this.slides.length;
      if (matchMedia('(min-width:960px)').matches) {
        this.requestedGalleryIndex = next;
        const request = ++this.galleryRequest;
        const image = this.slides[next].querySelector('img');
        if (image) image.loading = 'eager';
        const ready = image?.decode ? image.decode().catch(() => {}) : Promise.resolve();
        ready.then(() => {
          if (request !== this.galleryRequest || !this.isConnected || !matchMedia('(min-width:960px)').matches) return;
          this.slides.forEach((slide, i) => slide.classList.toggle('is-current', i === next));
          this.updateGallery(next);
        });
        return;
      }
      const request = this.mobileImageRequest = (this.mobileImageRequest || 0) + 1;
      const image = this.slides[next].querySelector('img');
      if (image) image.loading = 'eager';
      const ready = image?.decode ? image.decode().catch(() => {}) : Promise.resolve();
      ready.then(() => {
        if (request !== this.mobileImageRequest || !this.isConnected || matchMedia('(min-width:960px)').matches) return;
        const stage = this.querySelector('[data-stage]');
        const slide = this.slides[next];
        this.mobileScrollTarget = next;
        clearTimeout(this.mobileSettleTimer);
        this.mobileSettleTimer = setTimeout(() => { this.mobileScrollTarget = null; }, 1200);
        this.updateGallery(next);
        stage.scrollTo({
          left: stage.scrollLeft + slide.getBoundingClientRect().left - stage.getBoundingClientRect().left,
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
        });
        const adjacent = this.slides[next + 1]?.querySelector('img');
        if (adjacent) adjacent.loading = 'eager';
      });
    }

    updateGallery(index) {
      this.current = index;
      this.slides.forEach((slide, i) => slide.classList.toggle('is-current', i === index));
      this.thumbs.forEach((thumb, i) => {
        thumb.classList.toggle('is-active', i === index);
        thumb.setAttribute('aria-current', String(i === index));
      });
      const thumb = this.thumbs[index];
      if (thumb) {
        const rail = thumb.parentElement;
        if (matchMedia('(min-width:960px)').matches) {
          const top = thumb.offsetTop;
          const bottom = top + thumb.offsetHeight;
          if (top < rail.scrollTop || bottom > rail.scrollTop + rail.clientHeight) {
            rail.scrollTo({ top: top < rail.scrollTop ? top : bottom - rail.clientHeight,
              behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
          }
        } else {
          const left = thumb.offsetLeft;
          const right = left + thumb.offsetWidth;
          if (left < rail.scrollLeft || right > rail.scrollLeft + rail.clientWidth) {
            rail.scrollTo({ left: left < rail.scrollLeft ? left : right - rail.clientWidth,
              behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
          }
        }
      }
      const counter = this.querySelector('[data-count]');
      if (counter) counter.textContent = `${index + 1} / ${this.slides.length}`;
    }
    normalizeQuantity() {
      const min = Number(this.quantity.min) || 1;
      const step = Number(this.quantity.step) || 1;
      const max = this.quantity.max ? Number(this.quantity.max) : Infinity;
      const value = Number(this.quantity.value) || min;
      this.quantity.value = Math.max(min, Math.min(max, min + Math.round((value - min) / step) * step));
      this.syncQuantity();
    }
    changeQuantity(direction) {
      this.quantity.value = Number(this.quantity.value || this.quantity.min) + direction * (Number(this.quantity.step) || 1);
      this.normalizeQuantity();
    }
    syncQuantity() {
      this.querySelector('[data-sticky-quantity]').textContent = this.quantity.value || this.quantity.min;
      this.querySelector('[data-qty-minus]').disabled = this.busy || Number(this.quantity.value) <= Number(this.quantity.min);
      this.querySelector('[data-qty-plus]').disabled = this.busy || Boolean(this.quantity.max && Number(this.quantity.value) >= Number(this.quantity.max));
    }
    updateVariant(updateUrl) {
      const option = this.variantSelect?.selectedOptions[0];
      if (option) {
        for (const selector of ['[data-price]', '[data-mobile-price]']) this.querySelector(selector).textContent = option.dataset.price;
        for (const key of ['compare']) {
          const node = this.querySelector(`[data-${key}]`);
          node.textContent = option.dataset[key] || '';
          node.hidden = !option.dataset[key];
        }
        this.querySelector('[data-weight-wrap]').hidden = !(Number(option.dataset.weight) > 0);
        this.querySelector('[data-weight]').textContent = option.dataset.weight;
        this.querySelector('[data-sticky-variant]').textContent = option.textContent;
        this.available = option.dataset.available === 'true';
        this.quantity.min = option.dataset.min || '1';
        this.quantity.step = option.dataset.step || '1';
        if (option.dataset.max) this.quantity.max = option.dataset.max;
        else this.quantity.removeAttribute('max');
        if (updateUrl && location.pathname.includes('/products/')) {
          const url = new URL(location.href);
          url.searchParams.set('variant', option.value);
          history.replaceState({}, '', url);
        }
      }
      this.clearFeedback();
      this.normalizeQuantity();
      this.setBusy(false);
    }
    setBusy(value) {
      this.busy = value;
      this.form.setAttribute('aria-busy', String(value));
      [this.mainButton, this.stickyButton].filter(Boolean).forEach(button => {
        button.disabled = value || !this.available;
        button.setAttribute('aria-busy', String(value));
      });
      this.querySelectorAll('[data-cart-text]').forEach(label => {
        label.textContent = value ? this.dataset.addingLabel : this.available ? this.dataset.cartLabel : this.dataset.soldOutLabel;
      });
      this.quantity.disabled = value;
      if (this.variantSelect) this.variantSelect.disabled = value;
      this.syncQuantity();
    }
    clearFeedback() {
      for (const selector of ['[data-form-error]', '[data-sticky-feedback]']) this.querySelector(selector).hidden = true;
    }
    showFeedback(message) {
      const target = this.querySelector('[data-form-error]');
      target.textContent = message;
      target.hidden = false;
      this.querySelector('[data-sticky-message]').textContent = message;
      this.querySelector('[data-sticky-feedback]').hidden = false;
    }
    async buyNow() {
      if (this.busy || !this.available) return;
      this.normalizeQuantity();
      if (!this.form.reportValidity()) return;
      const variantId = new FormData(this.form).get('id');
      const quantity = Number(this.quantity.value);
      if (!variantId || !Number.isSafeInteger(quantity) || quantity < 1) {
        this.showFeedback(this.dataset.buyError);
        return;
      }
      this.clearFeedback();
      this.setBusy(true);
      const openDialogs = new Set(document.querySelectorAll('dialog[open], [aria-modal="true"]'));
      const bodyOverflow = getComputedStyle(document.body).overflow;
      let added = false;
      try {
        const response = await fetch(this.dataset.cartAddUrl, {
          method: 'POST',
          body: new FormData(this.form),
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
        });
        let result;
        try { result = await response.json(); }
        catch { location.assign(this.dataset.cartUrl); return; }
        if (!response.ok || result.status) throw new Error(result.description || result.message || this.dataset.buyError);
        added = true;
        let cart;
        for (let attempt = 0; attempt < 2; attempt++) {
          const cartResponse = await fetch(`${this.dataset.cartUrl}.js`, {
            credentials: 'same-origin',
            cache: 'no-store',
            headers: { Accept: 'application/json' }
          });
          if (!cartResponse.ok) throw new Error(this.dataset.buyError);
          cart = await cartResponse.json();
          if (Array.isArray(cart.items) && cart.items.some(item => String(item.variant_id || item.id) === String(variantId) && item.quantity > 0)) break;
          if (attempt === 0) await new Promise(resolve => setTimeout(resolve, 300));
        }
        if (!Array.isArray(cart.items) || !cart.items.some(item => String(item.variant_id || item.id) === String(variantId) && item.quantity > 0)) throw new Error(this.dataset.buyError);
        document.dispatchEvent(new CustomEvent('namma:cart-updated', { detail: { cartData: cart } }));
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cartData: cart, cart } }));
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cartData: cart, cart } }));
        await new Promise(resolve => setTimeout(resolve, 350));
        const yukoDrawer = [...document.querySelectorAll('[id*="yuko" i][id*="drawer" i], [class*="yuko" i][class*="drawer" i]')]
          .some(node => {
            const rect = node.getBoundingClientRect();
            const style = getComputedStyle(node);
            return rect.width > 0 && rect.height > 0 && rect.right > 0 && rect.left < innerWidth && style.visibility !== 'hidden' && style.opacity !== '0' && node.getAttribute('aria-hidden') !== 'true';
          });
        const newDialog = [...document.querySelectorAll('dialog[open], [aria-modal="true"]')].some(node => !openDialogs.has(node));
        const lockedPage = bodyOverflow !== 'hidden' && getComputedStyle(document.body).overflow === 'hidden';
        if (!yukoDrawer && !newDialog && !lockedPage) {
          const cartLink = document.querySelector('.nih__cart, .nh__cart, #cart-icon-bubble, a.header__icon--cart, a[href="' + this.dataset.cartUrl + '"]');
          if (cartLink) cartLink.click();
          else location.assign(this.dataset.cartUrl);
        }
      } catch (failure) {
        if (added) location.assign(this.dataset.cartUrl);
        else this.showFeedback(failure.message || this.dataset.buyError);
      } finally {
        if (this.isConnected) this.setBusy(false);
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["namma-taste-spotlight"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('namma-taste-spotlight-v10')) {
    customElements.define('namma-taste-spotlight-v10', class extends HTMLElement {
      connectedCallback() {
        if (!this.querySelector('[data-status]')) {
          this.readyObserver?.disconnect();
          this.readyObserver = new MutationObserver(() => {
            if (!this.querySelector('[data-status]')) return;
            this.readyObserver.disconnect();
            this.connectedCallback();
          });
          this.readyObserver.observe(this, { childList: true, subtree: true });
          return;
        }
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.tabs = Array.from(this.querySelectorAll('[data-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-panel]'));
        this.rail = this.querySelector('[data-rail]');
        this.panelTrack = this.querySelector('[data-panels]');
        this.status = this.querySelector('[data-status]');
        if (!this.tabs.length) return;
        this.rail.setAttribute('role', 'tablist');
        this.rail.setAttribute('aria-orientation', 'horizontal');
        this.tabs.forEach((tab, index) => {
          tab.setAttribute('role', 'tab');
          tab.setAttribute('aria-controls', this.panels[index].id);
          this.panels[index].setAttribute('role', 'tabpanel');
          this.panels[index].setAttribute('aria-labelledby', tab.id);
          this.panels[index].tabIndex = 0;
        });
        this.setAttribute('data-enhanced', '');
        this.select(Number(this.dataset.initialIndex) || 0, { center: false });
        this.addEventListener('click', (event) => {
          if (Date.now() < (this.suppressClickUntil || 0)) {
            event.preventDefault();
            return;
          }
          const tab = event.target.closest('[data-tab]');
          if (tab && this.contains(tab)) {
            event.preventDefault();
            this.select(this.tabs.indexOf(tab), { announce: true });
            return;
          }
          const button = event.target.closest('[data-step]');
          if (!button || !this.contains(button)) return;
          const step = Number(button.dataset.step);
          const wasInsidePanel = !!button.closest('[data-panel]');
          this.select(this.index + step, { announce: true });
          if (wasInsidePanel) {
            this.panels[this.index].querySelector(`[data-step="${step}"]`)?.focus({ preventScroll: true });
          }
        }, options);
        this.rail.addEventListener('keydown', (event) => {
          const tab = event.target.closest('[data-tab]');
          if (!tab) return;
          const position = this.tabs.indexOf(tab);
          const rtl = getComputedStyle(this.rail).direction === 'rtl';
          let next;
          if (event.key === 'ArrowRight') next = position + (rtl ? -1 : 1);
          if (event.key === 'ArrowLeft') next = position + (rtl ? 1 : -1);
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = this.tabs.length - 1;
          if (event.key === ' ') next = position;
          if (next === undefined) return;
          event.preventDefault();
          this.select(next, { focus: true });
        }, options);
        document.addEventListener('shopify:block:select', (event) => {
          const index = this.panels.findIndex((panel) => panel.dataset.blockId === event.detail?.blockId);
          if (index >= 0) this.select(index);
        }, options);
        this.addEventListener('wheel', (event) => {
          if (this.dataset.gestureNavigation !== 'true') return;
          if (window.matchMedia('(max-width: 699px)').matches) return;
          const horizontal = Math.abs(event.deltaX) > Math.abs(event.deltaY);
          const step = horizontal ? Math.sign(event.deltaX) : Math.sign(event.deltaY);
          if (!step || (step > 0 && this.index >= this.panels.length - 1) || (step < 0 && this.index <= 0)) return;
          event.preventDefault();
          const now = Date.now();
          if (now < (this.wheelReadyAt || 0)) return;
          this.wheelReadyAt = now + 620;
          this.select(this.index + step, { announce: true });
        }, { ...options, passive: false });
        this.addEventListener('pointerdown', (event) => {
          if (this.dataset.gestureNavigation !== 'true') return;
          if (!window.matchMedia('(max-width: 699px)').matches || !event.isPrimary || event.button !== 0) return;
          if (event.target.closest('input, textarea, select')) return;
          this.pointerSwipe = { id: event.pointerId, x: event.clientX, y: event.clientY };
        }, options);
        this.addEventListener('pointermove', (event) => {
          const start = this.pointerSwipe;
          if (!start || start.id !== event.pointerId) return;
          const dx = event.clientX - start.x;
          const dy = event.clientY - start.y;
          if (Math.abs(dx) > 10 && Math.abs(dx) > Math.abs(dy) * 1.1) {
            start.dragged = true;
            if (!this.hasPointerCapture(event.pointerId)) this.setPointerCapture(event.pointerId);
            if (event.cancelable) event.preventDefault();
          }
        }, { ...options, passive: false });
        this.addEventListener('pointerup', (event) => {
          const start = this.pointerSwipe;
          if (!start || start.id !== event.pointerId) return;
          this.pointerSwipe = null;
          if (this.hasPointerCapture(event.pointerId)) this.releasePointerCapture(event.pointerId);
          const dx = event.clientX - start.x;
          const dy = event.clientY - start.y;
          if (!start.dragged || Math.abs(dx) < 30 || Math.abs(dx) <= Math.abs(dy) * 1.1) return;
          this.suppressClickUntil = Date.now() + 350;
          this.select(this.index + (dx < 0 ? 1 : -1), { announce: true });
        }, options);
        this.addEventListener('pointercancel', () => { this.pointerSwipe = null; }, options);
        this.addEventListener('touchstart', (event) => {
          if (this.dataset.gestureNavigation !== 'true') return;
          if (window.matchMedia('(max-width: 699px)').matches && 'PointerEvent' in window) return;
          const touch = event.changedTouches[0];
          this.swipeStart = { x: touch.clientX, y: touch.clientY };
        }, { ...options, passive: true });
        this.addEventListener('touchmove', (event) => {
          if (window.matchMedia('(max-width: 699px)').matches && 'PointerEvent' in window) return;
          if (!this.swipeStart) return;
          const touch = event.changedTouches[0];
          const dx = touch.clientX - this.swipeStart.x;
          const dy = touch.clientY - this.swipeStart.y;
          if (window.matchMedia('(max-width: 699px)').matches && Math.abs(dx) <= Math.abs(dy)) return;
          const distance = Math.abs(dx) > Math.abs(dy) ? -dx : -dy;
          const next = this.index + Math.sign(distance);
          if (Math.abs(distance) >= 24 && next >= 0 && next < this.panels.length) event.preventDefault();
        }, { ...options, passive: false });
        this.addEventListener('touchend', (event) => {
          if (window.matchMedia('(max-width: 699px)').matches && 'PointerEvent' in window) return;
          if (!this.swipeStart) return;
          const touch = event.changedTouches[0];
          const dx = touch.clientX - this.swipeStart.x;
          const dy = touch.clientY - this.swipeStart.y;
          this.swipeStart = null;
          if (window.matchMedia('(max-width: 699px)').matches && Math.abs(dx) <= Math.abs(dy)) return;
          const distance = Math.abs(dx) > Math.abs(dy) ? -dx : -dy;
          if (Math.abs(distance) < 45) return;
          const step = Math.sign(distance);
          const next = this.index + step;
          if (next < 0 || next >= this.panels.length) return;
          this.select(next, { announce: true });
        }, { ...options, passive: true });
        this.resizeObserver = new ResizeObserver(() => {
          this.updateShape();
          this.centerActive(false);
        });
        this.resizeObserver.observe(this.rail);
        this.resizeObserver.observe(this.panelTrack);
      }

      disconnectedCallback() {
        this.readyObserver?.disconnect();
        this.controller?.abort();
        this.resizeObserver?.disconnect();
      }

      select(index, { center = true, focus = false, announce = false } = {}) {
        this.index = (index + this.tabs.length) % this.tabs.length;
        this.tabs.forEach((tab, position) => {
          const active = position === this.index;
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
          this.panels[position].removeAttribute('hidden');
          this.panels[position].setAttribute('aria-hidden', String(!active));
          this.panels[position].inert = !active;
          this.panels[position].style.setProperty('--nb-slide-offset', `${(position - this.index) * 100}%`);
        });
        this.querySelectorAll('[data-current]').forEach((counter) => {
          counter.textContent = String(this.index + 1).padStart(2, '0');
        });
        this.panelTrack.style.setProperty('--nb-active-bg', this.panels[this.index].style.getPropertyValue('--nb-bg'));
        this.panelTrack.style.setProperty('--nb-active-highlight', this.panels[this.index].style.getPropertyValue('--nb-highlight'));
        this.style.setProperty('--nb-active-highlight', this.panels[this.index].style.getPropertyValue('--nb-highlight'));
        if (announce) this.status.textContent = this.panels[this.index].dataset.announcement;
        if (focus) this.tabs[this.index].focus({ preventScroll: true });
        if (!this.shapePlaced) this.updateShape();
        if (center) this.centerActive(false);
      }

      updateShape() {
        if (!this.tabs?.length) return;
        const shape = this.querySelector('[data-fixed-shape]');
        if (!shape) return;
        const panel = this.panels[this.index];
        const scene = panel.querySelector('.nb-tastes__scene');
        const product = panel.querySelector('.nb-tastes__product');
        const desktop = window.matchMedia('(min-width: 1000px)').matches;
        const mobile = window.matchMedia('(max-width: 699px)').matches;
        const width = product.offsetWidth * (desktop ? 1.1 : 1.08);
        if (!width) return;
        shape.style.left = `${scene.offsetLeft + product.offsetLeft + (product.offsetWidth - width) / 2}px`;
        shape.style.width = `${width}px`;
        shape.style.top = desktop ? '0px' : `${scene.offsetTop + product.offsetTop}px`;
        shape.style.height = `${desktop ? this.panelTrack.clientHeight * .95 : product.offsetHeight}px`;
        const neck = shape.querySelector('.nb-tastes__shape-neck');
        const capWidth = this.tabs[this.index].offsetWidth * 1.25;
        if (mobile) {
          const mobileWidth = this.panelTrack.clientWidth;
          shape.style.left = '0px';
          shape.style.top = '0px';
          shape.style.width = `${mobileWidth}px`;
          shape.style.height = `${scene.offsetTop + product.offsetTop + product.offsetHeight + 20}px`;
          const mobileNeck = shape.querySelector('.nb-tastes__shape-mobile-neck');
          if (mobileNeck) {
            const half = capWidth / mobileWidth * 300;
            const left = 300 - half;
            const right = 300 + half;
            mobileNeck.setAttribute('d', `M${left}-20H${right}V0C${right} 25 450 30 453 80C460 130 445 145 495 170C540 195 545 215 550 260C555 295 590 305 592 345C600 385 565 410 565 438C565 470 595 490 545 535C495 570 490 610 425 620C365 645 325 610 270 598C205 580 165 620 90 602C35 590-20 560-10 500C-5 455 60 430 85 395C115 345 130 325 185 318C235 310 285 330 330 295C375 265 345 235 325 205C300 170 320 150 300 110C280 65 ${left} 35 ${left} 0V-20Z`);
          }
        }
        if (desktop && neck) {
          const half = (capWidth / width) * 300;
          const left = 280 - half;
          const right = 280 + half;
          neck.setAttribute('d', `M${left}-20H${right}V0C${right} 80 370 62 392 145C412 225 570 205 585 285C624 358 540 420 520 500C500 580 455 585 375 580C285 566 250 563 175 582C75 612 24 570 25 494C24 421 130 402 125 332C122 292 83 270 111 226C146 179 215 165 205 110C198 57 ${left} 65 ${left} 0V-20Z`);
        }
        const cap = this.querySelector('[data-fixed-cap]');
        if ((desktop || window.matchMedia('(max-width: 699px)').matches) && cap) {
          const rootBounds = this.getBoundingClientRect();
          const railBounds = this.rail.getBoundingClientRect();
          const trackBounds = this.panelTrack.getBoundingClientRect();
          const neckCenter = desktop ? shape.getBoundingClientRect().left + width * 280 / 600 : railBounds.left + railBounds.width / 2;
          const capTop = railBounds.top - rootBounds.top + (desktop ? 10 : 0);
          cap.style.left = `${neckCenter - rootBounds.left - capWidth / 2}px`;
          cap.style.top = `${capTop}px`;
          cap.style.width = `${capWidth}px`;
          cap.style.height = `${trackBounds.top - rootBounds.top - capTop + 2}px`;
        }
        this.shapePlaced = true;
      }

      centerActive(smooth) {
        if (!this.tabs?.length) return;
        const tabRect = this.tabs[this.index].getBoundingClientRect();
        const railRect = this.rail.getBoundingClientRect();
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const shape = this.querySelector('[data-fixed-shape]');
        const target = window.matchMedia('(min-width: 1000px)').matches && shape && this.shapePlaced
          ? shape.getBoundingClientRect().left + shape.getBoundingClientRect().width * 280 / 600 - railRect.left
          : railRect.width / 2;
        this.rail.scrollBy({
          left: tabRect.left + tabRect.width / 2 - railRect.left - target,
          behavior: smooth && !reduced ? 'smooth' : 'instant'
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["namma-video-stories"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('namma-video-stories-v1')) {
    customElements.define('namma-video-stories-v1', class extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => this.initialize());
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        cancelAnimationFrame(this.scrollFrame);
        clearTimeout(this.statusTimer);
        this.events?.abort();
        this.resizeObserver?.disconnect();
        this.visibilityObserver?.disconnect();
        this.querySelectorAll('video').forEach(video => video.pause());
      }
      initialize() {
        this.events?.abort();
        this.resizeObserver?.disconnect();
        this.visibilityObserver?.disconnect();
        this.track = this.querySelector('[data-track]');
        this.cards = [...this.querySelectorAll('[data-card]')];
        if (!this.track || !this.cards.length) return;
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.previous = this.querySelector('[data-previous]');
        this.next = this.querySelector('[data-next]');
        this.navigation = this.querySelector('[data-navigation]');
        this.current = this.querySelector('[data-current]');
        this.status = this.querySelector('[data-status]');
        this.querySelectorAll('[data-play]').forEach(button => { button.hidden = !!button.closest('[data-card]').querySelector('[data-player] video'); });
        this.addEventListener('click', event => {
          const button = event.target.closest('[data-play]');
          if (button && this.contains(button)) this.playCard(button.closest('[data-card]'));
        }, options);
        this.previous.addEventListener('click', () => this.move(-1), options);
        this.next.addEventListener('click', () => this.move(1), options);
        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track || event.altKey || event.ctrlKey || event.metaKey) return;
          const rtl = getComputedStyle(this.track).direction === 'rtl';
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            event.preventDefault();
            this.move((event.key === 'ArrowRight' ? 1 : -1) * (rtl ? -1 : 1));
          } else if (event.key === 'Home' || event.key === 'End') {
            event.preventDefault();
            this.goTo(event.key === 'Home' ? 0 : this.cards.length - 1);
          }
        }, options);
        this.track.addEventListener('scroll', () => {
          cancelAnimationFrame(this.scrollFrame);
          this.scrollFrame = requestAnimationFrame(() => this.update());
          clearTimeout(this.statusTimer);
          this.statusTimer = setTimeout(() => { this.status.textContent = this.cards[this.geometry().index].getAttribute('aria-label'); }, 180);
        }, { ...options, passive: true });
        document.addEventListener('play', event => {
          if (!(event.target instanceof HTMLVideoElement) || !event.target.closest('namma-video-stories-v1')) return;
          this.querySelectorAll('video').forEach(video => { if (video !== event.target) video.pause(); });
        }, { ...options, capture: true });
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) this.querySelectorAll('video').forEach(video => video.pause());
        }, options);
        this.addEventListener('shopify:block:select', event => {
          const index = this.cards.findIndex(card => card.dataset.blockId === event.detail?.blockId);
          if (index >= 0) this.goTo(index, 'auto');
        }, options);
        this.visibilityObserver = new IntersectionObserver(entries => {
          entries.forEach(entry => { if (!entry.isIntersecting) entry.target.querySelectorAll('video').forEach(video => video.pause()); });
        });
        this.cards.forEach(card => this.visibilityObserver.observe(card));
        this.resizeObserver = new ResizeObserver(() => this.update());
        this.resizeObserver.observe(this.track);
        this.querySelectorAll('[data-player] video').forEach(video => this.attachVideoEvents(video));
        this.update();
      }
      attachVideoEvents(video) {
        const failedSources = new Set();
        video.addEventListener('error', event => {
          if (event.target instanceof HTMLTrackElement) return;
          if (event.target instanceof HTMLSourceElement) {
            failedSources.add(event.target);
            if (failedSources.size < video.querySelectorAll('source').length) return;
          }
          if (this.contains(video)) this.showError(video.closest('[data-card]'));
        }, { signal: this.events.signal, capture: true });
        video.addEventListener('pause', () => video.closest('[data-card]')?.querySelector('[data-media]').removeAttribute('aria-busy'), { signal: this.events.signal });
        video.addEventListener('playing', () => {
          const card = video.closest('[data-card]');
          if (!card) return;
          card.querySelector('[data-error]').hidden = true;
          card.querySelector('[data-media]').removeAttribute('aria-busy');
        }, { signal: this.events.signal });
      }
      playCard(card) {
        const button = card.querySelector('[data-play]');
        const player = card.querySelector('[data-player]');
        card.querySelector('[data-error]').hidden = true;
        card.querySelector('[data-media]').setAttribute('aria-busy', 'true');
        let video = player.querySelector('video');
        if (!video) {
          player.append(card.querySelector('[data-video-template]').content.cloneNode(true));
          video = player.querySelector('video');
          video.setAttribute('loading', 'eager');
          this.attachVideoEvents(video);
        }
        button.hidden = true;
        player.hidden = false;
        video.focus({ preventScroll: true });
        const result = video.play();
        result?.catch(error => {
          if (!this.isConnected || !this.contains(video) || error.name === 'AbortError') return;
          this.showError(card);
        });
      }
      showError(card) {
        const player = card.querySelector('[data-player]');
        player.querySelector('video')?.pause();
        player.replaceChildren();
        card.querySelector('[data-media]').removeAttribute('aria-busy');
        const button = card.querySelector('[data-play]');
        button.hidden = false;
        card.querySelector('[data-error]').hidden = false;
        button.focus({ preventScroll: true });
      }
      geometry() {
        const rect = this.track.getBoundingClientRect();
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        const distances = this.cards.map(card => { const bounds = card.getBoundingClientRect(); return rtl ? rect.right - bounds.right : bounds.left - rect.left; });
        let index = 0;
        distances.forEach((distance, i) => { if (Math.abs(distance) < Math.abs(distances[index])) index = i; });
        const maxScroll = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        const position = Math.abs(this.track.scrollLeft);
        return { index, distances, rtl, atStart: position < 2, atEnd: position >= maxScroll - 2, overflow: maxScroll > 2 };
      }
      update() {
        const state = this.geometry();
        this.navigation.hidden = !state.overflow;
        this.current.textContent = String(state.index + 1);
        this.previous.setAttribute('aria-disabled', String(state.atStart));
        this.next.setAttribute('aria-disabled', String(state.atEnd));
      }
      move(direction) {
        const state = this.geometry();
        if ((direction < 0 && state.atStart) || (direction > 0 && state.atEnd)) return;
        this.goTo(state.index + direction);
      }
      goTo(index, behavior) {
        const state = this.geometry();
        const target = Math.max(0, Math.min(index, this.cards.length - 1));
        this.track.scrollTo({ left: this.track.scrollLeft + state.distances[target] * (state.rtl ? -1 : 1), behavior: behavior || (matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth') });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
